import { z } from 'zod';
const hexColor = z
    .string()
    .regex(/^#?[0-9a-fA-F]{6}([0-9a-fA-F]{2})?$/, 'invalid hex color');
export const updateBrandKitSchema = z.object({
    logoMediaFileId: z.string().uuid().nullable().optional(),
    primaryColor: hexColor.nullable().optional(),
    secondaryColor: hexColor.nullable().optional(),
    accentColor: hexColor.nullable().optional(),
    backgroundColor: hexColor.nullable().optional(),
    headingFont: z.string().max(100).nullable().optional(),
    bodyFont: z.string().max(100).nullable().optional(),
    stylePromptSuffix: z.string().max(2000).nullable().optional(),
    referenceImageMediaFileIds: z.array(z.string().uuid()).max(20).optional(),
});
// --- Artwork generation ---
export const generateArtworkSchema = z.object({
    prompt: z.string().min(3).max(2000),
    width: z.number().int().min(64).max(4096).default(1024),
    height: z.number().int().min(64).max(4096).default(1024),
    episodeId: z.string().uuid().optional(),
});
//# sourceMappingURL=brand-kit.schemas.js.map